export default __webpack_public_path__ + "static/media/equipment.3436438c.png";